import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import TopNavBar from './TopNavBar';
import Sidebar from './Sidebar';

/** Shell for the authenticated admin experience: fixed top bar + sidebar. */
export default function DashboardLayout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-brand-bg">
      <TopNavBar onMenuClick={() => setNavOpen(true)} />
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <main className="mt-16 max-w-[1440px] p-4 sm:p-6 lg:ml-[280px]">
        <Outlet />
      </main>
    </div>
  );
}
